const formValidation = require('sfraScripts/components/formValidation');
const createErrorNotification = require('sfraScripts/components/errorNotification');
const kleber = require('../kleber/kleber');
const amartCheckout = require('../checkout/amart-checkout');

module.exports = function() {
	$('form.login').submit(function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		const form = $(this);
		const url = form.attr('action');
		$.spinner().start();
		//form.trigger('login:submit', e);
		$.ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: form.serialize(),
			success: function(data) {
				if (!data.success) {
					$.spinner().stop();
					formValidation(form, data);
					form.trigger('login:error', data);
				} else {
					window.dataLayer.push({
						event : "interaction",
						component : "account",
						action : "Successful Login"
					});
					form.trigger('login:success', data);
					amartCheckout.copyShippingToBilling();
					$.spinner().stop();
					location.href = data.redirectUrl;
				}
			},
			error: function(data) {
				if (data.responseJSON.redirectUrl) {
					window.location.href = data.responseJSON.redirectUrl;
				} else {
					form.trigger('login:error', data);
					$.spinner().stop();
				}
			},
		});
		return false;
	});

	$('#registrationForm').submit(function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		const url = $(this).attr('action');
		const form = $(this);
		$.spinner().start();
		form.trigger('login:register', e);
		var $recaptcha = form.closest($('[data-google-recaptcha]'));
		var recaptchaEnabled = $recaptcha.data('recaptchaEnabled');
		var recaptchaSiteKey = $recaptcha.data('recaptchaSiteKey');

		function callAjax(token) {
			var formData = form.serialize();
			if (token) {
				formData += '&token=' + token;
			}
			$.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: formData,
				success: function(data) {
					if (!data.validForm) {
						$.spinner().stop();
						formValidation(form, data);
						e.stopImmediatePropagation();
						e.preventDefault();
						e.stopPropagation();
					} else {
						window.dataLayer.push({
							event : "interaction",
							component : "account",
							action : "Account Created"
						});

						location.href = data.redirectUrl;
					}
				},
				error: function(err) {
					console.log(err);
					if (err.responseJSON.redirectUrl) {
						window.location.href = err.responseJSON.redirectUrl;
					} else {
						createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
					}
					$.spinner().stop();
				},
			});
		}

		if (recaptchaEnabled) {
			grecaptcha.ready(function () { // eslint-disable-line
				grecaptcha.execute(recaptchaSiteKey, {
					action: 'register'
				}).then(function (token) { // eslint-disable-line
					callAjax(token);
				});
			});
		} else {
			callAjax();
		}
		return false;
	});

	$('#contactUsForm').submit(function(e) {
		const form = $(this);
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		const url = $(this).attr('action');
		$.spinner().start();
		var $recaptcha = form.closest($('[data-google-recaptcha]'));
		var recaptchaEnabled = $recaptcha.data('recaptchaEnabled');
		var recaptchaSiteKey = $recaptcha.data('recaptchaSiteKey');

		function callAjax(token) {
			var formData = form.serialize();
			if (token) {
				formData += '&token=' + token;
			}

			$.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: formData,
				success: function (data) {
					if (data.errorMessage) {
						var errorMessageField = $(".alert.submitResult");
						errorMessageField.empty();
						errorMessageField.removeClass('d-none');
						errorMessageField.html("<p>" + data.errorMessage + "</p>");
						createErrorNotification($('.error-messaging'), data.errorMessage);
						$.spinner().stop();
					} else {
						window.location.href = data.redirectURL;
					}

				},
				error: function (err) {
					if (err.redirectURL) {
						window.location.href = err.redirectURL;
					} else {
						var errorMessageField = $(".alert.submitResult");
						errorMessageField.empty();
						errorMessageField.removeClass('d-none');
						errorMessageField.html("<p>" + err.errorMessage + "</p>");
						createErrorNotification($('.error-messaging'), err.errorMessage);
					}
					$.spinner().stop();
				},
			});
		}

		 if (recaptchaEnabled) {
		 	grecaptcha.ready(function () { // eslint-disable-line
		 		grecaptcha.execute(recaptchaSiteKey, {
		 			action: 'contactUs'
		 		}).then(function (token) { // eslint-disable-line
		 			callAjax(token);
		 		});
		 	});
		 } else {
		 	callAjax();
		 }
		 return false;
	});

	$('body').on('submit', '.reset-password-form', function (e) {
		const form = $(this);
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		const emailPattern = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
		const email = $('#reset-password-email').val();
		if (!emailPattern.test(email)) {
			$('#reset-password-email').addClass('is-invalid');
			$('#reset-password-email').closest('.form-group').find('.invalid-feedback').text('Please enter a valid email address.');
			return false;
		}
		const url = form.attr('action');
		$.spinner().start();
		var $recaptcha = form.closest($('[data-google-recaptcha]'));
		var recaptchaEnabled = $recaptcha.data('recaptchaEnabled');
		var recaptchaSiteKey = $recaptcha.data('recaptchaSiteKey');
		var checkoutLoginPage = $('#checkoutLoginPage').val();

		function callAjax(token) {
			var formData = form.serialize();
			if (token) {
				formData += '&token=' + token;
			}
			$.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: formData,
				success: function(data) {
					$.spinner().stop();
					if (!data.success) {
						formValidation(form, data);
					} else {
						var html = $('#requestPasswordResetModal').html();
						$('.request-password-body')
							.empty()
							.append(`<p>${data.receivedMsgBody}</p>`);
						if ($('#login').length) {
							$('#submitEmailButton')
								.text(data.buttonText)
								.attr('data-dismiss', 'modal');
						} else {
							if (checkoutLoginPage && checkoutLoginPage === 'true') {
								$('.send-email-btn')
									.empty()
									.html(
										`<a class="btn btn-primary btn-block" data-dismiss="modal">${data.buttonText}</a>`,
									);
							} else {
								$('.send-email-btn')
									.empty()
									.html(
										`<a href="${data.returnUrl}" class="btn btn-primary btn-block">${data.buttonText}</a>`,
									);
							}
						}
						if (checkoutLoginPage && checkoutLoginPage === 'true') {
							$('#requestPasswordResetModalBackup').empty().html(html);
						}
					}
				},
				error: function() {
					$.spinner().stop();
				},
			});
		}

		if (recaptchaEnabled) {
			grecaptcha.ready(function () { // eslint-disable-line
				grecaptcha.execute(recaptchaSiteKey, {
					action: 'resetpassword'
				}).then(function (token) { // eslint-disable-line
					callAjax(token);
				});
			});
		} else {
			callAjax();
		}
		return false;
	});

	$(document).on('invalid', '#contactUsForm', function (e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		$(this).addClass('was-validated');
	});

	$('#login .modal').on('hidden.bs.modal', function() {
		$('#reset-password-email').val('');
		$('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
	});

	$('body').on('click', '.guest-checkout-btn', function (e) {
		e.preventDefault();
		$('.checkout-login-action').removeClass('hidden');
	});

	$('body').on('click', '.login-btn[type!=submit]', function (e) {
		e.preventDefault();
		$('.checkout-login-action').addClass('hidden');
	});

	$(document).on('hidden.bs.modal', '#requestPasswordResetModal', function () {
		if ($("#submitEmailButton").data('dismiss') == 'modal') {
			location.reload();
			$.spinner().start();
		}

		var checkoutLoginPage = $('#checkoutLoginPage').val();
		if (checkoutLoginPage && checkoutLoginPage === 'true') {
			var html = $('#requestPasswordResetModalBackup').html();
			$('#requestPasswordResetModal').empty().html(html);
		}
	});
};
